import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { PUBLIC_DOMAIN } from '../../config/const.config';
import {
  fastSelectStyles,
  fastLabelStyles,
  fastErrorStyles,
} from '../../theme/fast-render-styles';

const PublicDomain = memo(
  ({
    id,
    name,
    defaultValue,
    label,
    onChange,
    disabled,
    sx,
    error,
    renderFast = false,
  }) => {
    if (renderFast) {
      return (
        <div style={{ width: '100%' }}>
          {label && (
            <label htmlFor={id} style={fastLabelStyles}>
              {label}
            </label>
          )}
          <select
            id={id}
            name={name}
            value={defaultValue ?? ''}
            onChange={onChange}
            disabled={disabled}
            style={{
              ...fastSelectStyles,
              ...(error ? { borderColor: '#d32f2f' } : {}),
              ...(disabled ? { opacity: 0.6, cursor: 'not-allowed' } : {}),
              ...sx,
            }}
          >
            {Object.keys(PUBLIC_DOMAIN).map((k) => (
              <option key={`${id}-v-${k}`} value={k}>
                {PUBLIC_DOMAIN[k]}
              </option>
            ))}
          </select>
          {error && <div style={fastErrorStyles}>{error}</div>}
        </div>
      );
    }

    return (
      <FormControl fullWidth error={error !== ''} variant="filled">
        <InputLabel id={`field-${id}-select-label`}>{label}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id={id}
          name={name}
          value={defaultValue}
          label={label}
          onChange={onChange}
          disabled={disabled}
          sx={sx}
        >
          {Object.keys(PUBLIC_DOMAIN).map((k) => (
            <MenuItem key={`${id}-v-${k}`} value={k}>
              {PUBLIC_DOMAIN[k]}
            </MenuItem>
          ))}
        </Select>
        {error !== '' && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    );
  }
);

PublicDomain.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  sx: PropTypes.shape(),
  error: PropTypes.string,
  renderFast: PropTypes.bool,
};
PublicDomain.defaultProps = {
  disabled: false,
  sx: {},
  error: '',
  renderFast: false,
};

export default PublicDomain;
